var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:(_vm.prefixClass + "-btn " + _vm.prefixClass + "-btn-text " + _vm.prefixClass + "-btn-icon-" + _vm.type),attrs:{"type":"button"}},_vm.$listeners),[_c('i',{class:(_vm.prefixClass + "-icon-" + _vm.type)})])}
var staticRenderFns = []

export { render, staticRenderFns }